import { fromJS, OrderedSet, Map } from "immutable";

import types from "./types";

import { RESET_VOTING_FORM } from "../types";

export const initialState = fromJS({
  campaignIdThatLaunchedForm: "",
  selectedCategory: "",
  selectedCampaigns: OrderedSet(),
  query: "",
  isModalOpen: false,
  loading: false,
  userId: "",
  error: "",
  totalVotes: null,
  availableVotes: null,
  validating: false,
  autoVote: false,
  donationId: "",
});

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.SET_DONATION_ID: {
      return state.set("donationId", payload.id);
    }

    case types.SET_AUTO_VOTE: {
      return state.set("autoVote", payload.autoVote);
    }
    case types.SET_VALIDATING: {
      return state.set("validating", payload.validating);
    }

    case types.SET_PARENT_CATEGORY: {
      return state.set("selectedCategory", action.category);
    }

    case types.SET_QUERY: {
      return state.set("query", action.query);
    }

    case types.TOGGLE_LOADING: {
      return state.set("loading", !state.get("loading"));
    }

    case types.TOGGLE_PAGINATION_LOAD: {
      return state.set("paginationLoading", !state.get("paginationLoading"));
    }

    case types.SET_CAMPAIGN: {
      return state.set("campaignIdThatLaunchedForm", id);
    }

    case types.SET_USER_ID: {
      return state.set("userId", action.id);
    }

    case types.SET_INITIAL_VOTES: {
      return state.withMutations((state) => {
        state.set("totalVotes", action.votes).set("availableVotes", action.votes);
      });
    }

    case types.ADD_CAMPAIGN: {
      return state.set(
        "selectedCampaigns",
        state.get("selectedCampaigns").add(action.campaign),
      );
    }

    case types.REMOVE_CAMPAIGN: {
      return state.withMutations((state) => {
        state
          .set(
            "availableVotes",
            state.get("availableVotes") + (action.campaign.get("votes") || 0),
          )
          .set(
            "selectedCampaigns",
            state.get("selectedCampaigns").delete(action.campaign),
          );
      });
    }

    case types.SET_VOTES: {
      const { campaign } = action;

      const numberVotes = parseInt(action.votes);
      const previousNumberOfVotes = campaign.get("votes") || 0;

      if (!Number.isNaN(numberVotes)) {
        const newVoteTotal = previousNumberOfVotes + numberVotes;

        const selectedCampaigns = state.get("selectedCampaigns");
        const oldCampaign = selectedCampaigns.get(campaign);
        const updatedCampaign = oldCampaign.set("votes", newVoteTotal);
        const updatedSelected = selectedCampaigns.map((campaign) => {
          if (campaign.get("id") == oldCampaign.get("id")) {
            return updatedCampaign;
          }
          return campaign;
        });

        let updatedTotalVotes = state.get("availableVotes") - numberVotes;

        return state.withMutations((state) => {
          state
            .set("selectedCampaigns", updatedSelected)
            .set("availableVotes", updatedTotalVotes);
        });
      } else {
        throw new Error(`${action.votes} is not a number`);
      }
    }

    case types.SUBMIT_ERROR: {
      return state.withMutations((state) => {
        state.set("submitError", action.error);
        state.set("error", action.error);
      });
    }

    case types.RESET_SEARCH_FILTERS: {
      return state.withMutations((state) => {
        state.set("query", "").set("selectedCategory", "");
      });
    }

    case types.RESET_SELECTED_VOTES: {
      const { totalVotes } = action;

      return state.withMutations((state) => {
        state
          .set("selectedCampaigns", state.get("selectedCampaigns").clear())
          .set("availableVotes", totalVotes);
      });
    }

    case RESET_VOTING_FORM: {
      return initialState;
    }

    default:
      return state;
  }
};
